import { Button, Modal, Form, Input, message, DatePicker } from "antd";
import API from "../../../../services/api-request";
import SelectProductType from "../../../../components/SelectProductType";
import dayjs from "dayjs";

const AddProductCost = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { first_week_fee, daily_fee, product_type_id, efective_date } =
      values;

    const dataForm = {
      first_week_fee,
      daily_fee,
      product_type_id,
      efective_date: dayjs(efective_date).format("YYYY-MM-DD"),
    };

    await API.Post("storage-cost", dataForm)
      .then(() => {
        message.success("Product has been added");
        props.onGetProductCost();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Product Cost"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Product Type"
            name="product_type_id"
            rules={[{ required: true, message: "Please input Product Type!" }]}
          >
            <SelectProductType />
          </Form.Item>
          <Form.Item
            label="Harga Minggu Pertama"
            name="first_week_fee"
            rules={[
              { required: true, message: "Please input Harga Minggu Pertama!" },
            ]}
          >
            <Input placeholder="Input Harga Minggu Pertama" />
          </Form.Item>
          <Form.Item
            label="Harga Harian"
            name="daily_fee"
            rules={[{ required: true, message: "Please input Harga Harian!" }]}
          >
            <Input placeholder="Input Harga Harian" />
          </Form.Item>
          <Form.Item
            label="Tanggal Efektif Date"
            name="efective_date"
            rules={[
              { required: true, message: "Please input Tanggal Efektif Date!" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddProductCost;
